import React, { useState, useEffect } from 'react';
import { skillsAPI } from '../../services/api';

const AdminSkills = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingSkill, setEditingSkill] = useState(null);
  const [formData, setFormData] = useState({ category: '', skills: [''] });

  useEffect(() => {
    loadSkills();
  }, []);

  const loadSkills = async () => {
    try {
      const response = await skillsAPI.getAll();
      setSkills(response.data);
    } catch (error) {
      console.error('Error loading skills:', error);
    }
  };

  const handleAdd = () => {
    setEditingSkill(null);
    setFormData({ category: '', skills: [''] });
    setShowModal(true);
  };

  const handleEdit = (skill) => {
    setEditingSkill(skill);
    setFormData({
      category: skill.category,
      skills: skill.skills.length > 0 ? skill.skills : [''],
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this skill category?')) return;

    try {
      await skillsAPI.delete(id);
      loadSkills();
    } catch (error) {
      console.error('Error deleting skill:', error);
      alert('Error deleting skill');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const skillsArray = formData.skills.filter(s => s.trim() !== '');
      if (editingSkill) {
        await skillsAPI.update(editingSkill.id, {
          category: formData.category,
          skills: skillsArray,
        });
      } else {
        await skillsAPI.create({
          category: formData.category,
          skills: skillsArray,
        });
      }
      setShowModal(false);
      loadSkills();
    } catch (error) {
      console.error('Error saving skill:', error);
      alert('Error saving skill');
    } finally {
      setLoading(false);
    }
  };

  const addSkillItem = () => {
    setFormData({ ...formData, skills: [...formData.skills, ''] });
  };

  const updateSkillItem = (index, value) => {
    const newSkills = [...formData.skills];
    newSkills[index] = value;
    setFormData({ ...formData, skills: newSkills });
  };

  const removeSkillItem = (index) => {
    const newSkills = formData.skills.filter((_, i) => i !== index);
    setFormData({ ...formData, skills: newSkills.length > 0 ? newSkills : [''] });
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-gray-800 dark:text-gray-200 text-2xl font-bold">Technical Skills</h2>
        <button className="btn btn-primary dark:bg-gradient-to-r dark:from-purple-600 dark:to-purple-700" onClick={handleAdd}>Add Skill Category</button>
      </div>

      <div className="item-list">
        {skills.map((skill) => (
          <div key={skill.id} className="item-card">
            <div className="item-card-content">
              <h3>{skill.category}</h3>
              <p>{skill.skills.join(', ')}</p>
            </div>
            <div className="item-card-actions">
              <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(skill)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(skill.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingSkill ? 'Edit Skill Category' : 'Add Skill Category'}</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Category</label>
                <input
                  type="text"
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Skills</label>
                {formData.skills.map((skill, index) => (
                  <div key={index} className="array-input-item">
                    <input
                      type="text"
                      value={skill}
                      onChange={(e) => updateSkillItem(index, e.target.value)}
                      placeholder="Enter skill"
                    />
                    {formData.skills.length > 1 && (
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => removeSkillItem(index)}>Remove</button>
                    )}
                  </div>
                ))}
                <button type="button" className="btn btn-secondary" onClick={addSkillItem} style={{ marginTop: '0.5rem' }}>
                  Add Skill
                </button>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSkills;

